<script>
export default {
  methods: {
    goToFilterList() {
      this.$router.push({ name: 'FilterList' });
    },
  },
};
</script>

<template>
  <div class="page-not-found">
    <v-layout column fill-height align-center justify-center>
      <v-icon
        class="mb-2"
        size="150px"
        color="error">
        block
      </v-icon>
      <div class="display-2 mb-5">
        {{ $t('pageNotFound.title') }}
      </div>
      <div class="heading mb-1">
        {{ $t('pageNotFound.text') }}
      </div>
      <v-btn color="primary" @click="goToFilterList">
        {{ $t('pageNotFound.button') }}
      </v-btn>
    </v-layout>
  </div>
</template>

<style lang="scss">
  .page-not-found {
    height: calc(100vh - 64px);
  }
</style>



// WEBPACK FOOTER //
// src/pages/error-pages/PageNotFound.vue